<div class="pagetitle clearfix">
  <h2>Tags{{ project?.name ? ': ' + project.name : '' }}</h2>
  <a href="javascript:;" class="btn btn-sm btn-outline-success" role="button" (click)="openDialog()"><i class="fa fa-fw fa-plus"></i> Create new tag</a>
</div>
<alert></alert>

<div class="table-responsive mt-2">
  <table class="table table-bordered table-striped table-sm table-hover" width="100%" cellspacing="0">
    <thead>
      <tr>
        <th class="sort-na">Name</th>
        <th class="sort-na">Colour</th>
        <th class="text-right sort-na">Files</th>
        <th width="250" class="sort-na">Action</th>
      </tr>
    </thead>
    <tbody>
      @if (loading || msg) {
        <tr><td colspan="4" class="loading text-center">{{ loading ? 'Loading...' : msg }}</td></tr>
      }
      @for (tag of tags; track tag.id) {
        <tr>
          <td><span class="badge" [style.background-color]="tag.color" [style.color]="tagTextColor(tag.color)">{{ tag.name }}</span></td>
          <td>{{ tag.color }}</td>
          <td class="text-right">{{ tag.fileCount | number }}</td>
          <td class="text-center">
            <a class="btn btn-primary btn-xs" [routerLink]="['/dashboard/project', projectId, 'tags', tag.id]" [state]="{ data: { project: project } }" [style.color]="'white'" title="View Tag"><i class="fas fa-eye"></i> View</a>&nbsp;
            <a class="btn btn-edit btn-xs" href="javascript:;" (click)="openDialog(tag)" title="Edit Tag"><i class="fa fa-fw fa-edit"></i> Edit</a>&nbsp;
            <a class="btn btn-delete btn-xs" href="javascript:;" (click)="deleteTag(tag)" title="Delete Tag"><i class="fa fa-fw fa-trash"></i> Delete</a>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<a [routerLink]="['/dashboard/project/list']" class="btn btn-sm btn-primary">Back to Project List</a>

<!-- invenire-v2's tag dialog: create, or edit the tag passed to openDialog -->
<ng-template #tagDialog let-modal>
  <form [formGroup]="tagForm" (ngSubmit)="saveTag()" novalidate>
    <div class="modal-header">
      <h3 class="modal-title">{{ editing ? 'Edit Tag' : 'Create Tag' }}</h3>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-left">
      <div class="form-group">
        <label for="tag-name">Name</label>
        <input id="tag-name" type="text" class="form-control form-control-sm" formControlName="name" placeholder="Tag name" aria-label="Tag name" maxlength="100">
      </div>
      <div class="form-group mb-0">
        <label for="tag-colour-code">Colour</label>
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <!-- through the form, so the colour code beside it follows (two inputs on one control don't update each other) -->
            <input type="color" class="input-group-text p-1" style="width: 2.75rem; height: 100%; cursor: pointer;" [value]="tagForm.value.color" (input)="tagForm.patchValue({ color: $any($event.target).value })" aria-label="Tag colour">
          </div>
          <input id="tag-colour-code" type="text" class="form-control" formControlName="color" aria-label="Tag colour code" placeholder="#000000">
        </div>
      </div>
      @for (error of formErrors; track error) {
        <div class="text-danger small mt-2">{{ error }}</div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-sm btn-outline-secondary" (click)="modal.dismiss()">Cancel</button>
      <button type="submit" class="btn btn-sm btn-primary" [disabled]="tagForm.invalid || submitted">{{ editing ? 'Save tag' : 'Create tag' }}</button>
    </div>
  </form>
</ng-template>
